export interface IAppSettings {
    buildMode: "Development" | "Test" | "Staging" | "Training" | "Production";
    reportServerUrl: string;
    reportFolder: string;
}

export const AppSettings: IAppSettings = global.APPSETTINGS as IAppSettings;